
$(document).ready(function(){
  $(document).on('change','#variant-select-product-as-variant select',function(){
  var selected_variant = $(this).find('option:selected').attr('data-value');
   $('.main-product-page .product-as-variant-main label[data-handle="'+selected_variant+'"]').trigger('click');
});
  $(document).on('click','.product-as-variant-main label',function(e){
    e.preventDefault();
       var current = this;
    var this1 = $(this);
     var checked_val = $('variant-radios .js.product-form__input input:checked').attr('value');
    var selected_val =$('variant-selects .main_selector option').filter(":selected").val();
console.log(selected_val);
   var lb_cls = $(this).attr('for');
     var hndl = $(this).parents('.product-as-variant-main').find('input[id="'+lb_cls+'"]').attr('data-phandle');
    if($(current).parents().hasClass('quick-add-modal__content-info')){
       $(this).parents('.product-as-variant-main').find('.lading_product_icon').hide();
     }else{
    $(this).parents('.product-as-variant-main').find('.lading_product_icon').show();
    }
     if($(current).parents().hasClass('quick-add-modal__content-info')){
      $(this).parents('.product-as-variant-main').find('.lading_product_icon').hide();
        }else{
    //$('.loader-main').css('display','flex');
        }
 $('product-modal').remove();
    var url = 'product-as-variant';
    if($('body').hasClass('temp-product-new_vendor')){
       url = 'new-vendor-product-as-variant'
    }
   
   $.ajax({
      method: "GET",
      url:hndl+`?view=${url}`,
      async: true,
      success: function(data) {
       
        var reviews_widgets = $('.review_widget_bottom').html();
       if(!$(current).parents().hasClass('quick-add-modal__content-info')){
          var url = window.location.href;
         window.history.pushState({href: url}, '', hndl);
        }
        $(current).parents('.main-product-ctm').html($('.main-product-ctm',data).html());
         
        $('.product__info-wrapper.grid__item .jdgm-preview-badge').remove();
        $('.product__info-wrapper.grid__item .review-button').append(reviews_widgets);
      
    var id = $('.check_pd .bogo_pd-check').attr('data-id');
    var bogo_off = $('.check_pd .bogo_pd-check').attr('data_off');
   $('.product__info-wrapper.grid__item').find('product-form .bogo_product').attr('disabled',false);
    $('.product__info-wrapper.grid__item').find('product-form .bogo_pd_id1').val(id);
   $('.product__info-wrapper.grid__item').find('product-form .bogo_off1').val(bogo_off);
    
     /***** main bundle save price ************/
   var save_price = 0;
var actual_price =0;
  var orignial_price =0;

    $('.main-bundle-product-container .check_pd .check-input:checked').each(function(e){
     save_price = parseInt($(this).parents('.bundle-product-list').find('.card-wrapper .bundle_price_off').attr('data-save-p')) + save_price;
  actual_price =  parseInt($(this).parents('.bundle-product-list').find('.card-wrapper .bundle_price_off').attr('data-actual-p')) + actual_price;
orignial_price =  parseInt($(this).parents('.bundle-product-list').find('.card-wrapper .bundle_price_off').attr('data-original-price')) + orignial_price;
    });
   var save_price_total =Shopify.formatMoney(save_price);
var actual_price_total =Shopify.formatMoney(actual_price);
    var orignial_price_total =Shopify.formatMoney(orignial_price);
$('.bundle_main_add_to_cart .total_main_container span.save_price').attr('data-save-price',save_price);
$('.bundle_main_add_to_cart .total_main_container span.main_price').attr('data-total',actual_price);
$('.bundle_main_add_to_cart .total_main_container span.save_price').html(save_price_total);
$('.bundle_main_add_to_cart .total_main_container span.main_price').html(actual_price_total);
 $('.bundle_main_add_to_cart .total_main_container span.orignial_price').attr('data-orignial_price',orignial_price);
$('.bundle_main_add_to_cart .total_main_container span.orignial_price').html(orignial_price_total);
 /***** main bundle save price end************/
$("fieldset.variant_slider").flickity({
  contain: true,
  pageDots: false,
  accessibility: true, //true by default
  autoPlay: false, // advance cells every 3 seconds
  groupCells: true
});
     if($('.main-product-page').find('.why-this-product-content').length > 0){
      $('.main-product-page').find('.whyProductTitle').show();
      } 

       
        $(document).trigger("skio:plan-picker:init");
        $('.loader-main').hide();
     
      $('.main-product-page').find('variant-radios .js.product-form__input input[value="'+checked_val+'"]').attr('checked','checked');
      $('.main-product-page').find('variant-selects .main_selector option[value="'+selected_val+'"]').attr('selected',true);
    setTimeout(function(){eventFire(document.querySelector('.main-product-page variant-radios input'), 'change'); 
                         eventFire(document.querySelector('.main-product-page variant-selects .main_selector'), 'change'); 
                         },500); 
         var p_title = $('.product__title .title').html();
      $('.active_link').html(p_title);
      }
     
   });
    
 
    
    });
function eventFire(el, etype){
// console.log(el);
if(el != null){
  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    console.log(evObj);
    el.dispatchEvent(evObj);
  }
}
}
});